// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./background_pattern_decorative.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./background_pattern_circle.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.width-fit-content {
    width: fit-content;
}

.image-fit {
    object-fit: contain;
}

.flex_row_center {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.full-white-page {
    min-width: 100%;
    max-width: 100%;
    overflow: auto;
    min-height: 100vh;
    max-height: 100%;
    background-color: white;
}

.full-white-page-with-square {
    min-width: 100%;
    max-width: 100%;
    overflow: auto;
    min-height: 100vh;
    max-height: 100%;
    background-color: white;

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: center -300px;
}

.full-white-page-with-circle {
    min-width: 100%;
    max-width: 100%;
    overflow: auto;
    min-height: 100%;
    max-height: 100%;
    background-color: white;

    background-image:
            radial-gradient(
                    circle at center,
                    rgba(255, 255, 255, 0) 0%,
                    rgba(255, 255, 255, 0) 10%,
                    rgba(255, 255, 255, 0.5) 30%,
                    white 50%
            ),
            url(${___CSS_LOADER_URL_REPLACEMENT_1___});

    background-repeat: no-repeat;
    background-position: center -130px;
    background-size: 480px 480px;
}

.content-in-center {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.content_top_center {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.register-form-block {
    max-width: 360px;
    min-width: 360px;
    max-height: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;

    .logo-slot {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        max-height: 80px;
    }

    .title-and-switch {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 24px;
    }
}

.switch {
    width: 100%;
    border: 1px solid #E9EAEB;
    border-radius: 8px;
    background-color: #FAFAFA;
    color: #697586;
    display: flex;
    flex-direction: row;
    gap: 2px;

    .item_switch {
        cursor: pointer;
        width: 50%;
        height: 100%;
        padding: 8px 12px;
        border-radius: 8px;
        text-align: center;
    }

    .isActive {
        color: black;
        background-color: white;
        cursor: default;
    }

    .isActiveRight {
        border-left: 1px solid #E9EAEB;
    }

    .isActiveLeft {
        border-right: 1px solid #E9EAEB;
    }
}

.checked_list_body {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;

    .list_item {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        gap: 8px;

        .icon {
            width: 20px;
            height: 20px;
        }

        p {
            font-weight: 400;
            font-size: 14px;
            color: #4B5565;
        }

        .isTrue {
            color: #008a00;
        }

        .isFalse {
            color: #D5D7DA;
        }
    }
}

.userForm {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
}

.row_center {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.gap_32px {
    gap: 32px;
}

.forgot_form {
    max-width: 360px;
    min-width: 360px;
    max-height: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;

    .input_block {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 16px;
    }
}

.align-center {
    min-height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;;IAEvB,yDAA4D;IAC5D,4BAA4B;IAC5B,kCAAkC;AACtC;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;;IAEvB;;;;;;;;mDAQ8C;;IAE9C,4BAA4B;IAC5B,kCAAkC;IAClC,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;;IAET;QACI,WAAW;QACX,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;QACvB,SAAS;IACb;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;;IAER;QACI,eAAe;QACf,UAAU;QACV,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,uBAAuB;QACvB,eAAe;IACnB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,+BAA+B;IACnC;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;;IAET;QACI,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,mBAAmB;QACnB,2BAA2B;QAC3B,QAAQ;;QAER;YACI,WAAW;YACX,YAAY;QAChB;;QAEA;YACI,gBAAgB;YAChB,eAAe;YACf,cAAc;QAClB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,cAAc;QAClB;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;;IAET;QACI,WAAW;QACX,aAAa;QACb,sBAAsB;QACtB,SAAS;IACb;AACJ;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB","sourcesContent":[".width-fit-content {\n    width: fit-content;\n}\n\n.image-fit {\n    object-fit: contain;\n}\n\n.flex_row_center {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n}\n\n.full-white-page {\n    min-width: 100%;\n    max-width: 100%;\n    overflow: auto;\n    min-height: 100vh;\n    max-height: 100%;\n    background-color: white;\n}\n\n.full-white-page-with-square {\n    min-width: 100%;\n    max-width: 100%;\n    overflow: auto;\n    min-height: 100vh;\n    max-height: 100%;\n    background-color: white;\n\n    background-image: url('./background_pattern_decorative.png');\n    background-repeat: no-repeat;\n    background-position: center -300px;\n}\n\n.full-white-page-with-circle {\n    min-width: 100%;\n    max-width: 100%;\n    overflow: auto;\n    min-height: 100%;\n    max-height: 100%;\n    background-color: white;\n\n    background-image:\n            radial-gradient(\n                    circle at center,\n                    rgba(255, 255, 255, 0) 0%,\n                    rgba(255, 255, 255, 0) 10%,\n                    rgba(255, 255, 255, 0.5) 30%,\n                    white 50%\n            ),\n            url('./background_pattern_circle.png');\n\n    background-repeat: no-repeat;\n    background-position: center -130px;\n    background-size: 480px 480px;\n}\n\n.content-in-center {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.content_top_center {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.register-form-block {\n    max-width: 360px;\n    min-width: 360px;\n    max-height: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n\n    .logo-slot {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        max-height: 80px;\n    }\n\n    .title-and-switch {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        gap: 24px;\n    }\n}\n\n.switch {\n    width: 100%;\n    border: 1px solid #E9EAEB;\n    border-radius: 8px;\n    background-color: #FAFAFA;\n    color: #697586;\n    display: flex;\n    flex-direction: row;\n    gap: 2px;\n\n    .item_switch {\n        cursor: pointer;\n        width: 50%;\n        height: 100%;\n        padding: 8px 12px;\n        border-radius: 8px;\n        text-align: center;\n    }\n\n    .isActive {\n        color: black;\n        background-color: white;\n        cursor: default;\n    }\n\n    .isActiveRight {\n        border-left: 1px solid #E9EAEB;\n    }\n\n    .isActiveLeft {\n        border-right: 1px solid #E9EAEB;\n    }\n}\n\n.checked_list_body {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n\n    .list_item {\n        width: 100%;\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: flex-start;\n        gap: 8px;\n\n        .icon {\n            width: 20px;\n            height: 20px;\n        }\n\n        p {\n            font-weight: 400;\n            font-size: 14px;\n            color: #4B5565;\n        }\n\n        .isTrue {\n            color: #008a00;\n        }\n\n        .isFalse {\n            color: #D5D7DA;\n        }\n    }\n}\n\n.userForm {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    width: 100%;\n}\n\n.row_center {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.gap_32px {\n    gap: 32px;\n}\n\n.forgot_form {\n    max-width: 360px;\n    min-width: 360px;\n    max-height: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n\n    .input_block {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        gap: 16px;\n    }\n}\n\n.align-center {\n    min-height: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
